import { useSale } from './useSale';
import { DOCUMENT_TYPE_CODES } from '../../constants/documentTypeCodes';
import { useExportInvoiceSale } from './useExportInvoiceSale';

export const useSaleTotalsEditor = () => {
  const { form } = useSale();
  const exportInvoice = useExportInvoiceSale();

  const documentCode = form?.documentType?.code;

  /**
   * Actualiza un campo editable de totales
   */
  const updateTotalField = async (
    key: string,
    value: number,
    recalculates?: boolean
  ) => {
    switch (documentCode) {
      case DOCUMENT_TYPE_CODES.EXPORT_INVOICE:
        return handleExportInvoiceUpdate(key, value, recalculates);

      // 🔜 FUTURO
      // case DOCUMENT_TYPE_CODES.TAX_CREDIT:
      //   return taxCredit.updateTotals(...);

      default:
        console.warn(
          `No existe handler de totales para documento ${documentCode}`
        );
    }
  };

  const handleExportInvoiceUpdate = async (
    key: string,
    value: number,
    recalculates?: boolean
  ) => {
    // Solo algunos campos son editables en exportación
    const payload: any = {};

    if (key === 'freight') payload.freight = value;
    if (key === 'insurance') payload.insurance = value;

    if (!Object.keys(payload).length) {
      console.warn(`Campo no editable en exportación: ${key}`);
      return;
    }

    return exportInvoice.handlerUpdateExportExtras(form.id, payload);
  };

  return {
    updateTotalField,
  };
};
